import { render, staticRenderFns } from "./DownloadTable.vue?vue&type=template&id=5ef51546&scoped=true"
import script from "./DownloadTable.vue?vue&type=script&lang=js"
export * from "./DownloadTable.vue?vue&type=script&lang=js"
import style0 from "./DownloadTable.vue?vue&type=style&index=0&id=5ef51546&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef51546",
  null
  
)

export default component.exports